import _ from 'lodash';
import React from 'react';

import { AttributePresentation } from 'models/configuration/attribute_def';
import CustomAttribute from '../custom_attribute';
import CustomAttributesSubgroup from '../custom_attributes/custom_attributes_subgroup';
import { ProfileCardType } from 'models/configuration/profile_card_def';

export function getAttributeDefsToShow(profileCardDef, customerProfileDef, customAttributes) {
  if (!profileCardDef || !customerProfileDef) {
    return [];
  }

  // from the profileCardDef, get the relevant attribute defs to show
  let attrDefsForCardChain;
  if (profileCardDef.type === ProfileCardType.BASIC_PROFILE && !profileCardDef.attrs) {
    // for the BASIC_INFO card *only*, absense of attrs equates to showing all attrs
    // this helps us w/ the default/0-config case
    attrDefsForCardChain = _(customerProfileDef.attributes);
  } else {
    let attributeDefsMap = _.keyBy(customerProfileDef.attributes, 'attr');

    attrDefsForCardChain = _(profileCardDef.attrs)
      .map(attrToRender => {
        return attributeDefsMap[attrToRender];
      })
      .filter(attrDef => {
        return !_.isEmpty(attrDef);
      });
  }

  // We don't want to render HIDDEN attributes, and we only want to render VISIBLE attributes
  // if they have a value. But we always render EDITABLE attributes (in case an agent wants
  // to populate the value from scratch)
  return attrDefsForCardChain
    .filter(
      attrDef =>
        attrDef.presentation === AttributePresentation.EDITABLE ||
        (attrDef.presentation === AttributePresentation.VISIBLE && customAttributes && customAttributes[attrDef.attr])
    )
    .value();
}

export function getPercentAttrAsNumber(percentAttr) {
  if (!percentAttr) {
    return;
  }

  // if there's a trailing % sign, trim that off before proceeding
  const lastCharacter = percentAttr.charAt(percentAttr.length - 1);
  if (lastCharacter === '%') {
    percentAttr = percentAttr.slice(0, -1);
  }

  return Number(percentAttr);
}

export function renderCustomAttributes(renderableAttributes, customAttributes, location) {
  const renderProps = {};
  // find all of the PERCENT attr types to be rendered in this group and find the highest maximum NUMBER value for them
  _.each(renderableAttributes, attrDef => {
    if (attrDef.type === 'PERCENT') {
      if (customAttributes && attrDef.attr in customAttributes) {
        let asNumber = getPercentAttrAsNumber(customAttributes[attrDef.attr]);
        if (!Number.isNaN(asNumber)) {
          if (!renderProps.hasOwnProperty('highWaterMark')) {
            renderProps.highWaterMark = asNumber;
          } else if (asNumber > renderProps.highWaterMark) {
            renderProps.highWaterMark = asNumber;
          }
        }
      }
    }
  });

  return _.map(renderableAttributes, attrDef => {
    let attributeValue =
      !customAttributes || !(attrDef.attr in customAttributes) ? null : customAttributes[attrDef.attr];
    return (
      <CustomAttribute
        key={`customAttribute-${attrDef.attr}`}
        def={attrDef}
        value={attributeValue}
        renderProps={renderProps}
        location={{ type: location }}
      />
    );
  });
}

export function renderCustomAttributesSubgroup(profileCardDef, customerProfileDef, customAttributes, location) {
  if (!profileCardDef || !customerProfileDef) {
    return [];
  }

  return _.map(profileCardDef.subgroups, (subgroupDef, index) => {
    return (
      <CustomAttributesSubgroup
        key={`customAttributesSubgroup-${subgroupDef.label + index}`}
        subgroupDef={subgroupDef}
        customerProfileDef={customerProfileDef}
        customAttributes={customAttributes}
        location={location}
      />
    );
  });
}

export function countSubgroupCustomAttributes(profileCardDef, customerProfileDef, customAttributes) {
  if (!profileCardDef || !customerProfileDef) {
    return 0;
  }

  return _.reduce(
    profileCardDef.subgroups,
    (attrsThusFar, subgroupDef) => {
      const subgroupCustomAttrs = getAttributeDefsToShow(subgroupDef, customerProfileDef, customAttributes);
      return attrsThusFar + subgroupCustomAttrs.length;
    },
    0
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/summary/lib/custom_attributes_helper.js